import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mav-cns-logo',
  templateUrl: './cns-logo.component.html',
  styleUrls: ['./cns-logo.component.scss']
})
export class CnsLogoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
